/**
 * Wrap your actions with preload to automatically log their return state.
 *
 * @module store/preload/preload-handler
 *
 * @param {Promise} resultPromise returned by your action
 * @param {String}  stage         short text describing what your function does, such as "Entity List"
 * @param {String}  vuexCommit
 * @returns {Promise} The promise returned by your action
 */

export const preload = async (resultPromise, stage, commit) => {
  commit('updatePreloadCount', {
    action: {
      name: stage,
      start: new Date().getTime(),
      status: 'Pending'
    }
  });
  try {
    const data = await resultPromise;

    commit('updatePreloadCount', {
      action: {
        name: stage,
        end: new Date().getTime(),
        status: 'Success'
      }
    });
    return data;
  } catch (e) {
    commit('updatePreloadCount', {
      action: {
        name: stage,
        end: new Date().getTime(),
        status: 'Failed'
      }
    });
  }
  return null;
};
